const exports = module.exports;

exports.isPartnersDashboard = (context, redirect_to = '/login') => process.env.REACT_APP_MODE === 'partners';

exports.notPartnerMode = () => !(process.env.REACT_APP_MODE === 'partners');
